import Immutable from 'immutable'
import * as types from '../constants/ScheduleActionTypes'
var moment = require('moment');
require('moment/locale/de');

const initialState = Immutable.Map({
	schedules: Immutable.Map()
});

const initialScheduleState = Immutable.Map({
	dragging: false,
	timespan: null,
	loading: false,
    updating: false,
    unsubscribe: null,
	schedule: new Immutable.Map({
		relevant: new Immutable.List(),
		corresponding: new Immutable.List(),
		all: new Immutable.List()
	}),
	lottery: '_',
	channel: '_',
	activeItem: null,
	drag_timestamp: null,
	move_timestamp_start: null,
	move_timestamp_end: null,
	grid_size: 900,
	selectedItem: null
})

function getScheduleById(state, scheduleId){
	let s = state.getIn(['schedules', scheduleId]);	
	if(typeof s === 'undefined' || s === null){
		s = initialScheduleState;
		return s.set('id', scheduleId);
	}
		
	return s;
}

function updateScheduleById(state, scheduleId, schedule){
	return state.setIn(['schedules', scheduleId], schedule);
}

function setUnsubscribeHandler(state, handler){
    let unsubscribe = state.get('unsubscribe');

    if(typeof unsubscribe === 'function'){
        try {
            draft.unsubscribe();
        }catch(e){
            console.log(e);
        }
    }
    
    return state.set('unsubscribe', handler);
}

function setTimespan(state, startInSeconds, endInSeconds){
	let timespan = new Immutable.Map();
	timespan = timespan.set('start', parseInt(startInSeconds));
	timespan = timespan.set('end', parseInt(endInSeconds));
	
	var start = moment(startInSeconds * 1000);
	var end = moment(endInSeconds * 1000);
	var seconds = endInSeconds - startInSeconds;
	
	timespan = timespan.set('seconds', seconds);
	
	var days = new Immutable.List();
	var timeobject = moment(start);
	
	do {
		let dayObject = timeobject.startOf('day');
		
		let day = (new Immutable.Map())
			.set('caption', dayObject.format('dddd'))
			.set('start', parseInt(dayObject.startOf('day').format('X')))
			.set('end', parseInt(dayObject.endOf('day').format('X')))
			;
		
		day = day.set('seconds', day.get('end') - day.get('start'));
		
		days = days.push(day);
		var timeobject = dayObject.add(1, 'days');
	}while(timeobject.isSameOrBefore(end, 'day'));
	
	timespan = timespan.set('days', days);
	
	return state.set('timespan', timespan);
}

function setDragPosition(state, timestamp, trackIdx){
	state = state.set('drag_timestamp', timestamp);	
	
	let activeItem = state.get('activeItem');
	
	if(activeItem !== null){
		
		var item = getActiveItem(state);
		
		/*if(activeItem.get('action') !== 'move')
			state = state.set('move_timestamp_start', null).set('move_timestamp_end', null);*/
		
		switch(activeItem.get('action')){
			case 'create':
				item = item.set('end', timestamp);
			break;
			case 'resize-before':
				item = item.set('start', timestamp);
			break;
			case 'resize-after':
				item = item.set('end', timestamp);
			break;
			case 'move':			
				if(activeItem.get('track') !== trackIdx){
					state = resetConflicts(state);
					state = moveActiveItemToTrack(state, trackIdx);
					item = getActiveItem(state);
				}
				
				let end = state.get('timespan').get('end');
				let start = state.get('timespan').get('start');
				
				state = state.set('move_timestamp_start', Math.max(start, timestamp + activeItem.get('offset-start')));
				state = state.set('move_timestamp_end', Math.min(end, timestamp + activeItem.get('offset-end')));
				
				item = item.set('start', Math.max(start, timestamp + activeItem.get('offset-start')));
				item = item.set('end', Math.min(end, timestamp + activeItem.get('offset-end')));
			break;
		}
		state = updateActiveItem(state, item);
		
		state = handleConflicts(state, false);
	}
	
	return state;
}

function moveActiveItemToTrack(state, newTrackIdx){
	let activeItem = state.get('activeItem');
	let currentTrackIdx = activeItem.get('track');
	let trackItem = activeItem.get('item');
	
	/*
	 * Aktuelles Track Item auf preview.deleted setzen
	 */
	let item = getActiveItem(state);
	item = item.set('preview', new Immutable.Map({
		deleted: true
	}));
	state = updateActiveItem(state, item);
	
	/*
	 * Speichern, dass das Item bereits einen (geloeschten) Eintrag im aktuellen Track besitzt
	 */
	if(!activeItem.has('item-in-track'))
		activeItem = activeItem.set('item-in-track', new Immutable.Map());
		
	activeItem = activeItem.setIn(['item-in-track', currentTrackIdx], trackItem);
	
	/*
	 * Pruefen, ob es fuer das Item bereits einen Eintrag im neuen Track gibt, ansonsten neuen Eintrag erstellen
	 */
	var itemInNewTrack = activeItem.getIn(['item-in-track', newTrackIdx]);
	if(typeof itemInNewTrack === 'undefined' || itemInNewTrack === null)
		itemInNewTrack = state.getIn(['schedule', 'relevant', newTrackIdx, 'items']).size;
	
	let newItem = item.set('index', itemInNewTrack);
	if(newItem.has('preview'))
		newItem = newItem.delete('preview');
	
	activeItem = activeItem.set('track', newTrackIdx);
	activeItem = activeItem.set('item', itemInNewTrack);
	
	state = state.set('activeItem', activeItem);
	state = updateActiveItem(state, newItem);	
	
	return state;
}

function resetConflicts(state){
	//Find overlapping elements
	let activeItem = state.get('activeItem');
	if(activeItem === null)return state;
	
	let item = getActiveItem(state);
	let trackIdx = activeItem.get('track');
	let items = state.getIn(['schedule', 'relevant', trackIdx, 'items']);
	
	items = items.map((it, itKey) => {
		if(itKey === activeItem.get('item'))
			return it;
		
		if(it.has('deleted') && it.deleted)
			return it;
		
		if(it.has('preview'))
			return it.delete('preview');
			
		return it;
	});
	
	return state.setIn(['schedule', 'relevant', trackIdx, 'items'], items);
}

function handleConflicts(state){
	//Find overlapping elements
	let activeItem = state.get('activeItem');
	if(activeItem === null)return state;
	
	let item = getActiveItem(state);
	let trackIdx = activeItem.get('track');
	let items = state.getIn(['schedule', 'relevant', trackIdx, 'items']);
	
	items = items.map((it, itKey) => {
		if(itKey === activeItem.get('item'))
			return it;
		
		if(it.has('deleted') && it.deleted)
			return it;
		
		//Elemente, die komplett innerhalb des Bereichs liegen, werden als zu loeschen markiert
		if(it.get('start') >= item.get('start') && it.get('end') <= item.get('end'))
			return it.set('preview', new Immutable.Map({
				deleted: true
			}));
		
		if(item.get('start') <= it.get('start') && it.get('start') <= item.get('end'))
			return it.set('preview', new Immutable.Map({
				start: item.get('end')
			}));
		
		if(item.get('start') <= it.get('end') && it.get('end') <= item.get('end'))
			return it.set('preview', new Immutable.Map({
				end: item.get('start')
			}));
		
		if(it.has('preview'))
			return it.delete('preview');
		
		return it;
	});
	
	return state.setIn(['schedule', 'relevant', trackIdx, 'items'], items);
}

function finishConflictHandling(state){
	let tracks = state.getIn(['schedule', 'relevant']);
	
	tracks = tracks.map((track) => {
		let items = track.get('items');
		items = items.map((it) => {
			if(!it.has('preview'))
				return it;
			
			it = it.merge(it.get('preview'));
			return it.delete('preview');
		});
		
		return track.set('items', items);
	});
	
	return state.setIn(['schedule', 'relevant'], tracks);
}

function dragStart(state, action, trackIdx, itemIdx, params){
	let activeItem = new Immutable.Map({
		action: action,
		track: trackIdx,
		item: itemIdx
	});
	
	if(action === 'move'){
		activeItem = activeItem.set('offset-start', params.offsetStart);
		activeItem = activeItem.set('offset-end', params.offsetEnd);
	}
	
	state = state.set('activeItem', activeItem);
	
	state = state.set('drag_timestamp', null);
	state = state.set('move_timestamp_start', null);
	state = state.set('move_timestamp_end', null);
	
	let item = getActiveItem(state);
	item = item.set('dragging', true);
	state = updateActiveItem(state, item);
	
	return state.set('dragging', true);	
}

function dragEnd(state){
	let item = getActiveItem(state);
	
	if(item !== null){
		item = item.set('dragging', false);
		state = updateActiveItem(state, item);
	}
	
	let activeItem = state.get('activeItem');
	
	if(activeItem !== null){
		state = state.set('activeItem', null);
	}
	
	state = finishConflictHandling(state);
		
	return state.set('dragging', false);	
}

function startCreate(state, timestamp, trackIdx, meta){
	state = state.set('dragging', true);
	
	let items = state.getIn(['schedule', 'relevant', trackIdx, 'items']);	
	let activeItem = new Immutable.Map({
		action: 'create',
		track: trackIdx,
		item: items.size,
		start: timestamp
	});
	
	state = state.set('activeItem', activeItem);
	
	items = items.push(new Immutable.Map({
		start: timestamp,
		end: timestamp,
		index: items.size,
		dragging: true,
		meta: Immutable.fromJS(meta)
	}));
	state = state.setIn(['schedule', 'relevant', trackIdx, 'items'], items);
	return state;
}

function getActiveItem(state){
	let activeItem = state.get('activeItem');
	
	if(activeItem === null)return null;
	
	let item = state.getIn(['schedule', 'relevant', activeItem.get('track'), 'items', activeItem.get('item')]);
	return item;
}

function updateActiveItem(state, item){
	let activeItem = state.get('activeItem');
	
	if(activeItem === null)return null;
	
	return state.setIn(['schedule', 'relevant', activeItem.get('track'), 'items', activeItem.get('item')], item);
}

function endCreate(state, timestamp, trackIdx){	
	let item = getActiveItem(state);
	item = item.set('dragging', false);
	state = updateActiveItem(state, item);
	
	state = state.set('activeItem', null);
	state = state.set('dragging', false);
	state = finishConflictHandling(state);
	return state;
}

function selectItem(state, itemIdx, trackIdx){
	return state.set('selectedItem', new Immutable.Map({
		item: itemIdx,
		track: trackIdx
	}));
}

function removeItem(state, itemIdx, trackIdx){
	state = state.set('selectedItem', null);
	return state.setIn(['schedule', 'relevant', trackIdx, 'items', itemIdx, 'deleted'], true);
}


function requestSchedule(state){
	return state;	
}

function receiveSchedule(state, scheduleData){	
	state = state.setIn(['schedule', 'all'], Immutable.fromJS(scheduleData));
    state = state.set('updating', false);
	state = applyFilter(state);
	
	return state;	
}

function startChangeTimespan(state){
	return state.set('loading', true);
}

function endChangeTimespan(state){
	return state.set('loading', false);
}

function requestSave(state){
	return state.set('loading', true);	
}

function receiveSave(state){
	return state.set('loading', false);	
}

function addTrack(state){
	let track = new Immutable.Map({
		items: new Immutable.List()	
	});
	
	let schedule = state.getIn(['schedule', 'relevant']);
	schedule = schedule.push(track);
	return state.setIn(['schedule', 'relevant'], schedule);
}

function setUpdating(state){
    return state.set('updating', true);
}

/**
 * Relevante Elemente auswählen
 * 
 * Anhand der ausgewählten Lotterie und des ausgewählten Channels werden die Elemente 
 * aus schedule.all in schedule.relevant und schedule.corresponding einsortiert.
 */
function applyFilter(state){
	let all = state.getIn(['schedule', 'all']);
	
	//Relevant sind nur Elemente, die genau fuer diesen Kanal und diesen Channel festgelegt wurden
	let priorities = new Immutable.Map({
		'relevant': new Immutable.Map(),
		'corresponding': new Immutable.Map()
	});
	let max = 0;
	let lottery = state.get('lottery');
	let channel = state.get('channel');
	
	for(var item of all){
		/*
		 * Pruefen, welche Rolle das Element hat
		 */

		let itemLotteries = item.get('lotteryId');
		if(typeof itemLotteries === 'undefined' || itemLotteries === null)itemLotteries = null;
		else itemLotteries = itemLotteries.toJSON();
			
		let itemChannels = item.get('channelId');
		if(typeof itemChannels === 'undefined' || itemChannels === null)itemChannels = null;
		else itemChannels = itemChannels.toJSON();
		
		let role = null;
		
		if(lottery !== '_' && channel !== '_'){
			//Es wurde eine Lottery und ein Channel ausgewählt...
			
			if(itemLotteries === null && itemChannels === null)
				role = 'corresponding';
			else if(itemLotteries === null && typeof itemChannels[channel] !== 'undefined' && itemChannels[channel])
				role = 'corresponding';
			else if(itemChannels === null && typeof itemLotteries[lottery] !== 'undefined' && itemLotteries[lottery])
				role = 'corresponding';
			else if(typeof itemChannels[channel] !== 'undefined' && itemChannels[channel] && typeof itemLotteries[lottery] !== 'undefined' && itemLotteries[lottery])
				role = 'relevant';
		}else if(lottery !== '_'){
			//Es wurde eine Lottery aber kein Channel ausgewählt...
			console.log(lottery, itemChannels, itemLotteries);
			if(itemLotteries === null && itemChannels === null)
				role = 'corresponding';
			else if(itemChannels === null && typeof itemLotteries[lottery] !== 'undefined' && itemLotteries[lottery])
				role = 'relevant';
		}else if(channel !== '_'){
			//Es wurde keine Lottery aber ein Channel ausgewählt...
			
			if(itemLotteries === null && itemChannels === null)
				role = 'corresponding';
			else if(itemLotteries === null && typeof itemChannels[channel] !== 'undefined' && itemChannels[channel])
				role = 'relevant';
		}else{
			//Es wurde keine Lottery und kein Channel ausgewählt...
			if(itemLotteries === null && itemChannels === null)
				role = 'relevant';
		}
		
		if(role === null)continue;
		
		let priority = parseInt(item.get('priority'));
		if(priority > max)
			max = priority;
		
		if(!priorities.get(role).has(priority)){
			let p = new Immutable.Map();
			p = p.set('items', new Immutable.List());
			priorities = priorities.setIn([role, priority], p);
		}
		
		let list = priorities.getIn([role, priority, 'items']);
		
		item = item.set('trackIdx', priority);
		item = item.set('index', list.size);
		
		list = list.push(Immutable.fromJS(item));
		priorities = priorities.setIn([role, priority, 'items'], list);
	}
	

	let relevant = Immutable.List();
	let corresponding = Immutable.List();
	
	for(var i = 0; i <= max; i++){
		let rel = new Immutable.Map({items: new Immutable.List()});
		let cor = new Immutable.Map({items: new Immutable.List()});
		if(priorities.hasIn(['relevant', i]))
			rel = priorities.getIn(['relevant', i]);
		if(priorities.hasIn(['corresponding', i]))
			cor = priorities.getIn(['corresponding', i]);
		
		relevant = relevant.push(rel);
		corresponding = corresponding.push(cor);
	}
	
	state = state.setIn(['schedule', 'relevant'], relevant);
	state = state.setIn(['schedule', 'corresponding'], corresponding);
	return state;
}

function updateFilter(state, lotteryId, channelId){
	state = state.set('lottery', lotteryId);
	state = state.set('channel', channelId);
	state = state.set('selectedItem', null);
	state = applyFilter(state);
	return state;
}

export default function schedule (state = initialState, action) {
	let schedule = null;
  switch (action.type) {
	case types.DRAG_START:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = dragStart(schedule, action.action, action.trackIdx, action.itemIdx, action.params);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.DRAG_END:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = dragEnd(schedule, action.scheduleId);
		return updateScheduleById(state, action.scheduleId, schedule);
	/*case types.SET_TIMESPAN:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = setTimespan(schedule, action.start, action.end);
		return updateScheduleById(state, action.scheduleId, schedule);*/
	case types.SET_DRAG_POSITION:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = setDragPosition(schedule, action.timestamp, action.trackIdx);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.START_CREATE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = startCreate(schedule, action.timestamp, action.trackIdx, action.meta);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.END_CREATE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = endCreate(schedule, action.timestamp, action.trackIdx);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.SELECT_ITEM:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = selectItem(schedule, action.itemIdx, action.trackIdx);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.REQUEST_SCHEDULE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = requestSchedule(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.RECEIVE_SCHEDULE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = receiveSchedule(schedule, action.schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.START_CHANGE_TIMESPAN:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = startChangeTimespan(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.END_CHANGE_TIMESPAN:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = setTimespan(schedule, action.start, action.end);
		schedule = endChangeTimespan(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.REQUEST_SAVE_SCHEDULE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = requestSave(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.RECEIVE_SAVE_SCHEDULE:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = receiveSchedule(schedule, action.schedule);
		schedule = receiveSave(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.ADD_TRACK:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = addTrack(schedule);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.UPDATE_FILTER:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = updateFilter(schedule, action.lotteryId, action.channelId);
		return updateScheduleById(state, action.scheduleId, schedule);
	case types.REMOVE_ITEM:
		schedule = getScheduleById(state, action.scheduleId);
		schedule = removeItem(schedule, action.itemIdx, action.trackIdx);
		return updateScheduleById(state, action.scheduleId, schedule);
    case types.UPDATING:
        schedule = getScheduleById(state, action.scheduleId);
        schedule = setUpdating(schedule);
        return updateScheduleById(state, action.scheduleId, schedule);
    case types.SET_UNSUBSCRIBE_HANDLER:
        schedule = getScheduleById(state, action.scheduleId);
        schedule = setUnsubscribeHandler(schedule, action.unsubscribe);
        return updateScheduleById(state, action.scheduleId, schedule);
    default:
      return state;
  }
}
